import { axios } from '@/utils/request'
const api = {
  rechargeSave: '/admin.php/setting/rechargeSave',
  rechargePre: '/admin.php/setting/rechargePre',
  printSave: '/admin.php/setting/printSave',
  printPre: '/admin.php/setting/printPre'
}
// 云码支付方案保存
export function rechargeSave (parameter) {
  return axios({
    url: api.rechargeSave,
    method: 'post',
    data: parameter
  })
}
// 云码支付方案预加载
export function rechargePre (parameter) {
  return axios({
    url: api.rechargePre,
    method: 'get',
    params: parameter
  })
}
// 打印支付方案保存
export function printSave(parameter) {
  return axios({
    url: api.printSave,
    method: 'post',
    data: parameter
  })
}
// 打印支付方案预加载
export function printPre (parameter) {
  return axios({
    url: api.printPre,
    method: 'get',
    params: parameter
  })
}
